import { Injectable } from '@angular/core';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { dateToText } from '../components/application/global.function';
import {
    IPayment,
    // IPaymentInfo,
    // TPaySystemInfo,
    // IRnumbInfoByPayment,
    IResponseCreatePayment,
    IResponsePayOrder,
    IResponseTypePaySystem,
} from '../interfaces/payment.interfaces';
import { IServiceSize } from '../interfaces/services.interfaces';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class PaymentsService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
    ) {}
    /*
     * @apiParam {Number} typePay  Тип платежа (22 - аванс)
     * @apiParam {Number} amount  Сумма
     * @apiParam {String} email  Почта
     * @apiParam {String} phone  Телефон
     * @apiParam {String} police Полис = ''
     */

    // Тип платежной системы
    public createPayment(
        typePay: Number,
        amount: Number | null,
        email: String | null,
        phone: String | null,
        police: String | null,
    ): Observable<IResponseCreatePayment> {
        const param = new Array();

        param.push('typePay=' + typePay);
        param.push('amount=' + amount);

        if (email != null) {
            param.push('email=' + email);
        }
        if (phone != null) {
            param.push('phone=' + phone);
        }
        if (police != null) {
            param.push('police=' + police);
        }

        const pr = param.join('&');
        const url = '/payments/create_order/ariadna_system?' + pr;
        return this.httpNew.get<IResponseCreatePayment>(url);
    }

    // Оплата
    public getPayOrder(orderId: number): Observable<IResponsePayOrder['data']> {
        return this.httpNew.post<IResponsePayOrder['data']>(
            `/payments/create_order/external_system`,
            { orderId: orderId },
        );
    }

    // Тип платежной системы
    public async getPaySystem(): Promise<IResponseTypePaySystem> {
        const res = await firstValueFrom(
            this.httpNew.get<IResponseTypePaySystem>(
                `/payments/list/external_paysystems`,
            ),
        );
        return res;
    }

    // Список платежей по пациенту
    public getPayments(
        pBeginDate: Date | null,
        pEndDate: Date | null,
        pStart?: number,
        pEnd?: number,
        // orderBy: string | null = 'acs'
    ): Observable<Array<IPayment>> {
        const param = new Array();
        if (pBeginDate != null) {
            param.push('beginDate=' + dateToText(pBeginDate));
        }
        if (pEndDate != null) {
            param.push('endDate=' + dateToText(pEndDate));
        }

        if (pStart && pEnd) {
            param.push('start=' + pStart);
            param.push('end=' + pEnd);
        }

        const pr = param.join('&');

        const url = '/payments/list?' + pr;

        const res = this.httpNew.get<Array<IPayment>>(url);

        return res;
    }

    /**
     * Получить количество записей
     */

    public getPaymentsSize(
        beginDate: Date | null,
        endDate: Date | null,
    ): Observable<IServiceSize> {
        const param = new Array();

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }
        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }

        const pr = param.join('&');
        const url = '/payments/list/size?' + pr;
        return this.httpNew.get<IServiceSize>(url);
    }

    // Информация о платеже upd: видимо устарело
    // public getPayment(paymentId: number): Observable<IPaymentInfo[]> {
    //     return this.httpNew.get(`/api/service/payment/${paymentId}`);
    // }

    /* Получение информации о платеже из талона  upd: видимо устарело*/
    // public getRnumbInfoByPayment(
    //     paymentId: number
    // ): Observable<IRnumbInfoByPayment[]> {
    //     return this.httpNew.get(`/api/payment/${paymentId}/rnumb/info`);
    // }
}
